export const ASSETS = {
  logo:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_810ab6b3-6015-41ff-8951-c016553ccc54/artifacts/sg48mstv_Logos_Tavola%20disegno%201%20copia%206%20%282%29.png%20YouTube%20Channel%20Icon.png",
  portrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_810ab6b3-6015-41ff-8951-c016553ccc54/artifacts/vqwqmmp3_AF8B4584-2%20copy%203.png",
  redCostume:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_810ab6b3-6015-41ff-8951-c016553ccc54/artifacts/1is5hyld_Cibele%20Roman%20Kostuum.png",
};

export const GALLERY = [
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/ji5hma8c_IMG_20251110_180341_353.webp",
    alt: "Cibele in a crystal-adorned red gown",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/8aklvrdy_Cibele%20BellyDancer%20%282%29.jpg",
    alt: "Cibele in an emerald green bellydance costume",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/s51loexn_Cibele%20BellyDancer%202%20%281%29.png",
    alt: "Cibele reclining in a fuchsia and gold costume",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/agipevax_Instagram%20post%20%281%29.jpg",
    alt: "Cibele in a royal blue costume with jewelled bodice",
  },
];

export const PHOTOS = {
  portrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/elqdkjfe_AF8B4584-2%20copy%203.png",
  istanbul:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/qb5tzlxq_Cibele%20Istanbul%20.webp",
  magazineCover:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/d8aw71e6_Kybele%20Magazine.png",
  fuchsia:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/pxe9kxof_Cibele%20BellyDancer%202.webp",
  purpleStage:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/o9vls1j0_Cibele%20%20Gypsy%20Dancer.png",
  blackVelvet:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/vibp6x2n_DSC01555.jpg",
  green:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/8aklvrdy_Cibele%20BellyDancer%20%282%29.jpg",
  band:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dance-elegance-hub/artifacts/pqh1272u_cibelenadaragypsyband.webp",
};

export const SHOP_URL = "https://traveltheworldofbellydance.com";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Magazine", href: "#magazine" },
  { label: "Entertainment", href: "#entertainment" },
  { label: "B2B", href: "#b2b" },
  { label: "Contact", href: "#contact" },
];

export const CONTACT = {
  email: "info@cibeledance.com",
  whatsapp: "+31 6 52045930",
  whatsappHref: "https://wa.me/31652045930",
  city: "Amsterdam · Athens · Cairo · Istanbul",
};

export function scrollToId(id) {
  const el = document.querySelector(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
